export default function (initialDataInteractor, questionnaireId, newDescription) {
  let questionnaire = initialDataInteractor.data.questionnaires.find(q => q.id == questionnaireId);
  questionnaire.description = newDescription;
}